<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'ASSOCIATIONS.CONTACT.TITLE' | translate }}</mat-panel-title>
  </mat-expansion-panel-header>
  <button mat-stroked-button color="primary" class="button-company-association-card" (click)="openModal()">
    <mat-icon>add</mat-icon>
    {{ 'ASSOCIATIONS.CONTACT.ADD_ASSOCIATION' | translate }}
  </button>
  <ng-container *ngFor="let contact of contacts$ | async">
    <crm-association-card
      *ngIf="contact.userName"
      [cardData]="contact"
      [actions]="contact.cardActions"
      (removeClick)="removeAssociation(contact)"
      (editTagsClick)="editTags(contact)"
    >
      <ng-container *ngIf="contact.jobTitle">
        <crm-common-association-card-content [iconName]="'person'">
          <mat-card-subtitle>
            {{ contact.jobTitle }}
          </mat-card-subtitle>
        </crm-common-association-card-content>
      </ng-container>
      <ng-container *ngIf="contact.phone">
        <crm-common-association-card-content [iconName]="'phone'">
          <mat-card-subtitle>
            <a href="tel:{{ contact.phone }}">
              {{ contact.phone }}
            </a>
          </mat-card-subtitle>
        </crm-common-association-card-content>
      </ng-container>
      <ng-container *ngIf="contact.linkedInUrl">
        <crm-common-association-card-content [iconName]="'linkedin'" [isSvgIcon]="true">
          <mat-card-subtitle>
            <a class="linkedin-url-link" href="{{ contact.linkedInUrl }}" target="_blank">
              {{ contact.linkedInUrl }}
            </a>
          </mat-card-subtitle>
        </crm-common-association-card-content>
      </ng-container>
      <crm-common-association-card-content [iconName]="'store'">
        <app-crm-access-business-app
          [companyId]="data.company_id"
          [contactId]="contact.id"
          [contactName]="contact.userName"
          [companyName]="contact.companyName"
          [hasAccess]="contact.businessAppAccess.hasBusinessAppAccess$ | async"
          [desiredAccess$$]="contact.businessAppAccess.desiredBusinessAppAccess$$"
        ></app-crm-access-business-app>
      </crm-common-association-card-content>
      <ng-container *ngIf="contact.tags && contact.tags.length > 0">
        <crm-common-association-card-content [iconName]="'local_offer'">
          <crm-tags [tags]="contact.tags"></crm-tags>
        </crm-common-association-card-content>
      </ng-container>
    </crm-association-card>
  </ng-container>
  <button *ngIf="hasMore$ | async" mat-button color="primary" class="button-view-more" (click)="showMore()">
    <mat-icon>add</mat-icon>
    {{ 'ASSOCIATIONS.ACTIONS.SHOW_MORE' | translate: { count: pageSize } }}
  </button>
</mat-expansion-panel>
